import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Login from "./pages/login/Login";
import App from "./container";
import { isSignedIn } from "./auth/index";
import { ConfigProvider } from "./auth/context";
import RecuperarSenha from "./pages/recuperar/RecuperarSenha";
import RedefinirSenha from "./pages/redefinir/RedefinirSenha";
import PoliticaPertoTeachers from "./pages/politicaTeachers/PoliticaPertoTeachers";
import PoliticaPertoFamily from "./pages/politicaFamily/PoliticaPertoFamily";
import AcompanhamentoPedido from "./pages/acompanhamentoPedido";

const PrivateRoute = ({ component: Component, signed, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      signed ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);

const Routes = () => {
  const [userData, setUserData] = useState(undefined);
  const [signed, setSigned] = useState(false);
  const [signLoaded, setSignLoaded] = useState(false);

  useEffect(() => {
    validarSessao();
  }, []);

  const validarSessao = (atualizarUsuarioContext) => {
    const sessionData = isSignedIn();

    setSigned(sessionData.signed);
    setUserData(sessionData.userData);
    setSignLoaded(true);

    if (atualizarUsuarioContext) atualizarUsuarioContext(sessionData.userData);
  };

  if (!signLoaded) return null;

  return (
    <ConfigProvider userData={signed ? userData : {}}>
      <Router>
        <Switch>
          <Route
            path="/login"
            exact={true}
            render={(props) => (
              <Login {...props} validarSessao={validarSessao} />
            )}
          />

          <Route path="/recuperar-senha" component={RecuperarSenha} />
          <Route
            path={`/redefinir-senha/:token/:canal`}
            component={RedefinirSenha}
          />

          <Route
            path={`/pp-perto-teachers`}
            component={PoliticaPertoTeachers}
          />
          <Route path={`/pp-perto-family`} component={PoliticaPertoFamily} />
          <Route path={`/acompanhamento-pedido/:chaveAcompanhamento`} component={AcompanhamentoPedido} />

          <Redirect exact from={`/`} to={`/app`} />
          <PrivateRoute signed={signed} path="/app" component={App} />
          <Route path="*" component={() => <h1>Page not found</h1>} />
        </Switch>
      </Router>
    </ConfigProvider>
  );
};

export default Routes;
